import { gqlClient } from '@/api/graphql-client';
import projectKeys from '@/api/queries/project/keyFactory';
import { graphql } from '@/gql';
import {
  SyncAllMaterialsFromLinkedOpenSolarProjectMutation as _SyncAllMaterialsFromLinkedOpenSolarProjectMutation,
  SyncAllMaterialsFromLinkedOpenSolarProjectInput,
} from '@/gql/graphql';
import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

const SyncAllMaterialsFromLinkedOpenSolarProjectMutation = graphql(`
  mutation SyncAllMaterialsFromLinkedOpenSolarProject(
    $input: SyncAllMaterialsFromLinkedOpenSolarProjectInput!
  ) {
    syncAllMaterialsFromLinkedOpenSolarProject(input: $input)
  }
`);

const useSyncAllMaterialsFromLinkedOpenSolarProject = (args?: {
  projectId?: string;
  options?: UseMutationOptions<
    _SyncAllMaterialsFromLinkedOpenSolarProjectMutation,
    unknown,
    SyncAllMaterialsFromLinkedOpenSolarProjectInput
  >;
}) => {
  const queryClient = useQueryClient();
  const { onSuccess, ...restOptions } = args?.options ?? {};
  return useMutation({
    mutationFn: (input: SyncAllMaterialsFromLinkedOpenSolarProjectInput) => {
      return gqlClient.request(
        SyncAllMaterialsFromLinkedOpenSolarProjectMutation,
        {
          input,
        }
      );
    },
    onSuccess: (data, variables, context) => {
      if (args?.projectId) {
        void queryClient.invalidateQueries({
          queryKey: projectKeys.integrations(args.projectId),
        });
      }
      onSuccess?.(data, variables, context);
    },
    ...restOptions,
  });
};

export default useSyncAllMaterialsFromLinkedOpenSolarProject;
